import { Select } from "@/components/flexkit/select/Select";
import { type FC } from "react";

// eslint-disable-next-line react-refresh/only-export-components
export enum WorkflowExecutionStatusFilterValue {
    All = "all",
    Running = "running",
    Completed = "completed",
    Failed = "failed",
}

function toWorkflowExecutionStatusFilterValue(value: string): WorkflowExecutionStatusFilterValue {
    if (isWorkflowExecutionStatusFilterValue(value)) {
        return value;
    }
    // defaulting to 'All' if the value is unrecognized
    return WorkflowExecutionStatusFilterValue.All;
}

function isWorkflowExecutionStatusFilterValue(value: string): value is WorkflowExecutionStatusFilterValue {
    return Object.values(WorkflowExecutionStatusFilterValue).includes(value as WorkflowExecutionStatusFilterValue);
}

const statusFilterOptions = [
    {
        value: WorkflowExecutionStatusFilterValue.All,
        label: "All",
    },
    {
        value: WorkflowExecutionStatusFilterValue.Running,
        label: "Running",
    },
    {
        value: WorkflowExecutionStatusFilterValue.Completed,
        label: "Completed",
    },
    {
        value: WorkflowExecutionStatusFilterValue.Failed,
        label: "Failed",
    },
];

type WorkflowExecutionStatusFilterProps = {
    value: WorkflowExecutionStatusFilterValue;
    onChange: (value: WorkflowExecutionStatusFilterValue) => void;
};

export const WorkflowExecutionStatusFilter: FC<WorkflowExecutionStatusFilterProps> = ({ value, onChange }) => {
    return (
        <Select
            value={value}
            onValueChange={(v) => onChange(toWorkflowExecutionStatusFilterValue(v))}
            placeholder="Select status"
            className="min-w-44 grow"
            formatDisplayValue={(_, label) => <span>Status: {label}</span>}
            data-testid="workflow-execution-status-filter-trigger"
        >
            {statusFilterOptions.map((option) => (
                <Select.Item key={option.value} value={option.value}>
                    {option.label}
                </Select.Item>
            ))}
        </Select>
    );
};
